<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm">
      <div class="row">
        <div class="col-md-8">
          <div class="pt-3 mb-0 pb-0">
            <p class="font-weight-bold" style="line-height: 1px; color: #616161">
              PARÂMETROS
            <p style="line-height: 2px; font-size: 13px;">Marque abaixo os itens que você deseja que apareçam no painel
              principal do portal de transparência.</p>
          </div>
        </div>
        <div class="col-md-4">
          <a [routerLink]="['/transparencia']" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
          </a>
          <div class="dropdown float-right ml-2">
            <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenu2"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Outras Opções
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
              <a [routerLink]="['/usuarios']" class="dropdown-item">
                Usuários
              </a>
              <button data-toggle="modal" data-target="#dialogTrocarSenha" class="dropdown-item" type="button">
                Alterar Senha
              </button>
              <div class="dropdown-divider"></div>
              <button [routerLink]="['/orgaos', login.orgao.id, 'editar']" class="dropdown-item" type="button">
                Órgãos</button>
              <div class="dropdown-divider"></div>
              <button (click)="desconectar()" class="dropdown-item" type="button">Encerrar Sessão</button>
            </div>
          </div>
          <button (click)="submitForm()" class="btn btn-sm btn-info float-right mr-2"
            [disabled]="!podeIncluir('/admin/transparencia/parametros-transparencia')">
            Salvar
          </button>
        </div>
      </div>
      <hr class="mt-1" />
      <div class="row">
        <div *ngIf="podeVisualizar('contabil')" style="display: contents;">
          <div class="col-4 mt-2">
            <div class="row">
              <div class="col-md-12">
                <span class="font-weight-bold" style="color: #1565c0;">RECEITAS MUNICIPAIS</span>
                <hr class="mb-1 mt-0" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="painel_receita" type="checkbox" />
                    <span></span>
                    Painel receitas municipais
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="receita" type="checkbox" />
                    <span></span>
                    Arrecadação diária
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="receita_extra" type="checkbox" />
                    <span></span>
                    Receitas extra-orçamentárias
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="receita_recurso" type="checkbox" />
                    <span></span>
                    Receitas por fonte de recurso
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="arrecadacao_imposto" type="checkbox" />
                    <span></span>
                    Arrecadação de imposto
                  </label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="operacao_credito" type="checkbox" />
                    <span></span>
                    Operações de crédito
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2">
            <div class="row">
              <div class="col-md-12">
                <span class="font-weight-bold" style="color: #1565c0;">DESPESAS ORÇAMENTÁRIAS</span>
                <hr class="mb-1 mt-0" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="empenho" type="checkbox" />
                    <span></span>
                    Empenhos orçamentários
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="liquidacao" type="checkbox" />
                    <span></span>
                    Liquidações orçamentárias
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="pagamento" type="checkbox" />
                    <span></span>
                    Pagamentos orçamentários
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="despesa_recurso" type="checkbox" />
                    <span></span>
                    Despesas por fonte de recurso
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2">
            <div class="row">
              <div class="col-md-12">
                <span class="font-weight-bold" style="color: #1565c0;">DESPESAS EXTRAS</span>
                <hr class="mb-1 mt-0" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="despesa_extra" type="checkbox" />
                    <span></span>
                    Despesas extra-orçamentárias
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="pagamento_extra" type="checkbox" />
                    <span></span>
                    Pagamentos extra-orçamentários
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="empenho_resto" type="checkbox" />
                    <span></span>
                    Empenhos de restos a pagar
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="pagamento_resto" type="checkbox" />
                    <span></span>
                    Pagamentos de restos a pagar
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2">
            <div class="row">
              <div class="col-md-12">
                <span class="font-weight-bold" style="color: #1565c0;">OUTRAS CONSULTAS</span>
                <hr class="mb-1 mt-0" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="contrato" type="checkbox" />
                    <span></span>
                    Contratos e aditivos
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="licitacao" type="checkbox" />
                    <span></span>
                    Processos licitatórios
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="convenio" type="checkbox" />
                    <span></span>
                    Convênios
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="detalhar_convenio" type="checkbox" />
                    <span></span>
                    Exibir detalhamento do Convênio
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="ata" type="checkbox" />
                    <span></span>
                    Atas de registro
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="exportar_pdf" type="checkbox" />
                    <span></span>
                    Exportação em PDF
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="exportar_xls" type="checkbox" />
                    <span></span>
                    Exportação em XLS
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="exportar_xml" type="checkbox" />
                    <span></span>
                    Exportação em XML
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2">
            <div class="row">
              <div class="col-md-12">
                <span class="font-weight-bold" style="color: #1565c0;">TRANSFERÊNCIA DE RECURSOS</span>
                <hr class="mb-1 mt-0" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="transf_orgao" type="checkbox" />
                    <span></span>
                    Transferências entre orgãos
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="transf_estadual" type="checkbox" />
                    <span></span>
                    Transferências estaduais
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="transf_federal" type="checkbox" />
                    <span></span>
                    Transferências federais
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2">
            <div class="row">
              <div class="col-md-12">
                <span class="font-weight-bold" style="color: #1565c0;">CONSULTAS ESPECÍFICAS</span>
                <hr class="mb-1 mt-0" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="repasse" type="checkbox" />
                    <span></span>
                    Repasses ao terceiro setor
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="transf_privada" type="checkbox" />
                    <span></span>
                    Transferências instituições privadas
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="equipamento" type="checkbox" />
                    <span></span>
                    Equipamentos e material permanente
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="viagem" type="checkbox" />
                    <span></span>
                    Despesas de viagens
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="esic" type="checkbox" />
                    <span></span>
                    e-SIC
                  </label>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="entidadeForm.get('esic').value">
              <div class="col-12 mb-2">
                <label for="esic_url">URL e-sic</label>
                <input formControlName="esic_url" type="text" class="form-control" id="esic_url"
                  placeholder="informe a url do e-sic">
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-primary">
                  <label>
                    <input formControlName="outras_informacoes" type="checkbox" />
                    <span></span>
                    Outras Informações
                  </label>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="entidadeForm.get('outras_informacoes').value">
              <div class="col-12 mb-2">
                <label for="outras_informacoes_url">URL outras informações</label>
                <input formControlName="outras_informacoes_url" type="text" class="form-control"
                  id="outras_informacoes_url" placeholder="informe a url para outras informações">
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-danger">
                  <label>
                    <input formControlName="covid_despesa" type="checkbox" />
                    <span></span>
                    COVID-19 - Despesas
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="checkbox checbox-switch mt-2 switch-danger">
                  <label>
                    <input formControlName="covid_receita" type="checkbox" />
                    <span></span>
                    COVID-19 - Receitas
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-4 mt-2" *ngIf="podeVisualizar('recursos-humanos')">
          <div class="row">
            <div class="col-md-12">
              <span class="font-weight-bold" style="color: #1565c0;">RECURSOS HUMANOS</span>
              <hr class="mb-1 mt-0" />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <a [routerLink]="['/admin/transparencia/eventos-holerite']" class="btn btn-sm btn-link"
                style="margin-left: 36px;">Eventos (Holerite)</a>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="checkbox checbox-switch mt-2 switch-primary">
                <label>
                  <input formControlName="remuneracao" type="checkbox" />
                  <span></span>
                  Remuneração dos servidores
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="checkbox checbox-switch mt-2 switch-primary">
                <label>
                  <input formControlName="afastado" type="checkbox" />
                  <span></span>
                  Servidores públicos afastados
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="checkbox checbox-switch mt-2 switch-primary">
                <label>
                  <input formControlName="cedido" type="checkbox" />
                  <span></span>
                  Servidores públicos cedidos
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="checkbox checbox-switch mt-2 switch-primary">
                <label>
                  <input formControlName="cargo" type="checkbox" />
                  <span></span>
                  Cargos e salários
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="checkbox checbox-switch mt-2 switch-primary">
                <label>
                  <input formControlName="acumular_desconto_holerite" type="checkbox" />
                  <span></span>
                  Acumular descontos não visíveis
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="checkbox checbox-switch mt-2 switch-primary">
                <label>
                  <input formControlName="detalhar_holerite" type="checkbox" />
                  <span></span>
                  Exibir detalhamento do Holerite
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div *ngIf="podeVisualizar('contabil')" style="display: contents;">
          <div class="col-4 mt-2">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <div class="checkbox checbox-switch mb-2 switch-primary">
                      <label>
                        <input formControlName="conta_publica" type="checkbox" />
                        <span></span>
                        Contas públicas
                      </label>
                    </div>
                    <hr class="mb-1 mt-0" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-row">
                      <div class="col-12 mt-1">
                        <p-radioButton name="conta_tipo" value="R" label="Relatórios do sistema"
                          formControlName="conta_tipo">
                        </p-radioButton>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 mt-1">
                        <p-radioButton name="conta_tipo" value="U" label="Upload de arquivos"
                          formControlName="conta_tipo">
                        </p-radioButton>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 mt-1">
                        <p-radioButton name="conta_tipo" value="S" label="URL site da entidade"
                          formControlName="conta_tipo">
                        </p-radioButton>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" *ngIf="entidadeForm.get('conta_tipo').value === 'S'">
                  <div class="col-6 mb-4">
                    <label for="url">URL</label>
                    <input formControlName="url" type="text" class="form-control" id="url"
                      placeholder="informe a url do site da entidade para as contas públicas">
                  </div>
                </div>
                <div class="row" *ngIf="entidadeForm.get('conta_tipo').value === 'U'">
                  <div class="col-6 mb-4">
                    <a routerLink="/transparencia/contas-publica-anexos/CP" class="btn btn-sm btn-info">Fazer upload de
                      arquivos</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <div class="checkbox checbox-switch mb-2 switch-primary">
                      <label>
                        <input formControlName="planejamento" type="checkbox" />
                        <span></span>
                        Planejamento orçamentário
                      </label>
                    </div>
                    <hr class="mb-1 mt-0" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-row">
                      <div class="col-12 mt-1">
                        <p-radioButton name="plan_tipo" value="R" label="Relatórios do sistema"
                          formControlName="plan_tipo">
                        </p-radioButton>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 mt-1">
                        <p-radioButton name="plan_tipo" value="U" label="Upload de arquivos"
                          formControlName="plan_tipo">
                        </p-radioButton>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12 mt-1">
                        <p-radioButton name="plan_tipo" value="S" label="URL site da entidade"
                          formControlName="plan_tipo">
                        </p-radioButton>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" *ngIf="entidadeForm.get('plan_tipo').value === 'S'">
                  <div class="col-6 mb-4">
                    <label for="url">URL</label>
                    <input formControlName="plan_url" type="text" class="form-control" id="url"
                      placeholder="informe a url do site da entidade para o planejamento">
                  </div>
                </div>
                <div class="row" *ngIf="entidadeForm.get('plan_tipo').value === 'U'">
                  <div class="col-6 mb-4">
                    <a routerLink="/transparencia/contas-publica-anexos/PLAN" class="btn btn-sm btn-info">Fazer upload
                      de arquivos</a>
                  </div>
                </div>
                <div class="row" *ngIf="entidadeForm.get('plan_tipo').value === 'R'">
                  <div class="col mt-2 mb-4">
                    <div class="checkbox checbox-switch switch-danger">
                      <label>
                        <input type="checkbox" formControlName="mostrar_relatorio_loa" /><span></span>
                        Liberar anexos
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-4 mt-2">
          <div class="card">
            <div class="card-body">
              <div *ngIf="podeVisualizar('contabil')"
                style="display: contents;">
                <div class="row">
                  <div class="col-12">
                    <span class="font-weight-bold" style="color: #1565c0;">ANEXOS</span>
                    <hr class="mb-1 mt-2" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <a [routerLink]="['/admin/transparencia/atas-registro-anexos/pesquisa', 1, data1, data2]"
                      class="btn btn-sm btn-link">Atas de registro - anexar arquivos</a>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <a [routerLink]="['/admin/transparencia/empenhos-orcamentarios-anexos/pesquisa', 1, data1, data2]"
                      class="btn btn-sm btn-link">Empenhos - anexar arquivos</a>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <a [routerLink]="['/admin/transparencia/contratos-anexos/pesquisa', 1, data1, data2]"
                      class="btn btn-sm btn-link">Contratos e aditivos - anexar arquivos</a>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <a [routerLink]="['/admin/transparencia/licitacoes-anexos/pesquisa', 1, data1, data2]"
                      class="btn btn-sm btn-link">Licitações - anexar arquivos</a>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <a [routerLink]="['/transparencia/transparencia-arquivos']" class="btn btn-sm btn-link">Anexar
                    arquivos por grupo</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="mt-2 pt-1" />
      <div class="row" *ngIf="parametro">
        <div class="col-md-4">
          <span class="text-black-50 form-control form-control-plaintext">Última sincronização:
            {{parametro.data_atualizacao | date:'dd/MM/yyyy HH:mm'}}</span>
        </div>
      </div>
    </form>
  </div>
</div>

<app-transparencia-trocar-senha></app-transparencia-trocar-senha>